<template>
  <div>
    <div class="mt-4 md:flex items-center">
      <div
        class="w-full mt-4 md:mt-0"
        :class="isOneWay == 1 ? 'md:w-4/12' : 'md:w-6/12'"
      >
        <diffInput
        :disabled="isEdit"
          type="select"
          :optList="amortismanOptions"
          v-model="isAmortismanModel"
          title="Amortisman Maliyeti"
        />
      </div>
      <div
        class="w-full mt-4 md:mt-0 md:px-2"
        :class="isOneWay == 1 ? 'md:w-4/12' : 'md:w-6/12 md:pl-2'"
      >
        <diffInput
          :disabled="isEdit"
          type="select"
          :optList="oneWayOptions"
          v-model="isOneWayModel"
          title="Tek Yön"
        />
      </div>
      <div class="w-full md:w-4/12 mt-4 md:mt-0" v-if="isOneWay == 1">
        <diffInput
        :disabled="isEdit"
          type="number"
          :valCount="99"
          v-model="dayCountModel"
          :required="true"
          title="Gün Sayısı"
          :max="99"
          :min="1"
          :step="1"
        />
      </div>
    </div>
    
    <!-- İade Siparişi Checkbox -->
    <div class="mt-4 p-4 bg-yellow-50 dark:bg-yellow-900/20 rounded-lg border border-yellow-200 dark:border-yellow-800">
      <div class="flex items-center">
        <input
          type="checkbox"
          id="returnOrder"
          v-model="isReturnOrderModel"
          class="form-checkbox h-5 w-5 text-yellow-600 rounded focus:ring-yellow-500"
          :disabled="isEdit"
        />
        <label for="returnOrder" class="ml-2 font-semibold text-gray-800 dark:text-gray-100">
          İade Siparişi
        </label>
      </div>
      <p class="mt-2 text-sm text-gray-600 dark:text-gray-400">
        <strong>⚠️ Dikkat:</strong> Bu seçeneği işaretlediğinizde sipariş doğrudan <strong>"Boşaltıma Gidiyorum"</strong> durumundan başlayacaktır. 
        İade/geri dönüş işlemlerinde dolum aşaması atlanır ve araç direkt olarak boşaltma noktasına yönlendirilir.
      </p>
      
      <!-- İade Edilebilecek Siparişler Select - İade siparişi seçildiğinde göster -->
      <transition name="fade">
        <ReturnableOrderSelect
          v-if="isReturnOrderModel"
          :selectedOrder.sync="returnOrderIdModel"
          @orderSelected="handleOrderSelected"
        />
      </transition>
    </div>
  </div>
</template>
  
  <script>
import diffInput from "@/components/general/diffInput.vue";
import ReturnableOrderSelect from "./ReturnableOrderSelect.vue";

export default {
  name: "OptionFields",
  components: {
    diffInput,
    ReturnableOrderSelect,
  },
  props: {
    isAmortisman: {
      type: [String, Number],
      default: 1,
    },
    isOneWay: {
      type: [String, Number],
      default: 1,
    },
    dayCount: {
      type: [String, Number],
      default: 1,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    isReturnOrder: {
      type: Boolean,
      default: false,
    },
    returnOrderId: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      amortismanOptions: [
        {
          id: 1,
          name: "Eklensin",
        },
        {
          id: 2,
          name: "Eklenmesin",
        },
      ],
      oneWayOptions: [
        {
          id: 1,
          name: "Evet",
        },
        {
          id: 2,
          name: "Hayır",
        },
      ],
      dayCountModel: 1,
    };
  },
  computed: {
    isAmortismanModel: {
      get() {
        return this.isAmortisman;
      },
      set(value) {
        this.$emit("update:isAmortisman", value);
      },
    },
    isOneWayModel: {
      get() {
        return this.isOneWay;
      },
      set(value) {
        this.$emit("update:isOneWay", value);
      },
    },
    isReturnOrderModel: {
      get() {
        return this.isReturnOrder;
      },
      set(value) {
        this.$emit("update:isReturnOrder", value);
        // İade siparişi kapatıldığında seçili siparişi temizle
        if (!value) {
          this.$emit("update:returnOrderId", null);
        }
      },
    },
    returnOrderIdModel: {
      get() {
        return this.returnOrderId;
      },
      set(value) {
        this.$emit("update:returnOrderId", value);
      },
    },
  },
  methods: {
    handleOrderSelected(orderDetail) {
      // Seçilen siparişin detaylarını parent component'e ilet
      this.$emit("returnOrderSelected", orderDetail);
    },
  },
  watch: {
    dayCountModel(newVal) {
      if (this.isOneWayModel == 1) {
        this.$emit("dayCountChange", newVal);
      }
    },
    dayCount(val){
      this.dayCountModel=val;
    }
  },
};
</script>